module.exports = __webpack_public_path__ + "media/images/1-85a5b75e07bebfa05733664ee0ecf0d5.png";